// extracted by mini-css-extract-plugin
module.exports = {"root":"Hidden-root-f624dc6a06a34ed4aae4822ef75b9617"};